"use strict";

const AssetTypeConfig = function () {
  var get = function (assetType) {
    const configs = {
      outfall: {
        inventoryDataTemplate: "modals/assetRoutineMaintenance/inventoryData/outfall.njk",
        inventoryDataHandler: OutfallInventoryData,
        mapAssetToAssetInfo: OutfallInventoryData.mapAssetToAssetInfo,
        getMaintenanceTaskConfigKey: () => "outfalls",
        inspectionTypeOptions: [
          "routine-inspection",
          "wq-monitoring",
          "idde-screening",
          "idde-rescreen",
        ],
        downloadInspectionFile: ApiCalls.downloadOutfallInspectionFile,
      },
      bmpFcs: {
        inventoryDataTemplate: "modals/assetRoutineMaintenance/inventoryData/bmpFcs.njk",
        inventoryDataHandler: BmpFcsInventoryData,
        highlightRequiredFields: BmpFcsInventoryData.highlightRequiredFields,
        processUpdateData: BmpFcsInventoryData.processUpdateData,
        mapAssetToAssetInfo: BmpFcsInventoryData.mapAssetToAssetInfo,
        getMaintenanceTaskConfigKey: (assetInfo) => `bmp-${assetInfo.inventoryData.bmpType}`,
        capacityCalculationTaskKey: "debris-clogging",
        inspectionTypeOptions: ["routine-inspection", "idde-screening", "idde-rescreen"],
        downloadInspectionFile: ApiCalls.downloadBmpFcsFile,
      },
      // Hard asset types start offline inspections from their InspectableAssetCache of
      // server-built assetInfo, so they need no `mapAssetToAssetInfo`.
      manhole: {
        inventoryDataTemplate: "modals/assetRoutineMaintenance/inventoryData/manhole.njk",
        inventoryDataHandler: ManholeInventoryData,
        getMaintenanceTaskConfigKey: () => "manholes",
        inspectionTypeOptions: ["routine-inspection", "idde-screening", "idde-rescreen"],
        downloadInspectionFile: ApiCalls.downloadManholeFile,
      },
      // None of these types are IDDE monitoring locations.
      pipe: {
        inventoryDataHandler: NoInventoryData,
        getMaintenanceTaskConfigKey: () => "pipes",
        inspectionTypeOptions: ["routine-inspection"],
        downloadInspectionFile: (id) => ApiCalls.downloadHardAssetFile("pipe", id),
      },
      culvert: {
        inventoryDataHandler: NoInventoryData,
        getMaintenanceTaskConfigKey: () => "culverts",
        inspectionTypeOptions: ["routine-inspection"],
        downloadInspectionFile: (id) => ApiCalls.downloadHardAssetFile("culvert", id),
      },
      openChannel: {
        inventoryDataHandler: NoInventoryData,
        getMaintenanceTaskConfigKey: () => "open-channels",
        inspectionTypeOptions: ["routine-inspection"],
        downloadInspectionFile: (id) => ApiCalls.downloadHardAssetFile("openChannel", id),
      },
      liftStation: {
        inventoryDataHandler: NoInventoryData,
        getMaintenanceTaskConfigKey: () => "lift-stations",
        inspectionTypeOptions: ["routine-inspection"],
        downloadInspectionFile: (id) => ApiCalls.downloadHardAssetFile("liftStation", id),
      },
      cleanout: {
        inventoryDataHandler: NoInventoryData,
        getMaintenanceTaskConfigKey: () => "cleanouts",
        inspectionTypeOptions: ["routine-inspection"],
        downloadInspectionFile: (id) => ApiCalls.downloadHardAssetFile("cleanout", id),
      },
      "sampling-site": {
        inventoryDataHandler: SamplingSiteInventoryData,
        mapAssetToAssetInfo: SamplingSiteInventoryData.mapAssetToAssetInfo,
        inspectionTypeOptions: ["wq-monitoring", "idde-screening", "idde-rescreen"],
        downloadInspectionFile: ApiCalls.downloadSamplingSiteInspectionFile,
      },
    };

    const config = configs[assetType];
    if (!config) {
      throw new Error(`No configuration for asset type "${assetType}".`);
    }
    return config;
  };

  return {
    get,
  };
};

module.exports = AssetTypeConfig();

const ApiCalls = require("../../apiCalls");
const BmpFcsInventoryData = require("./inventoryData/bmpFcsInventoryData");
const ManholeInventoryData = require("./inventoryData/manholeInventoryData");
const NoInventoryData = require("./inventoryData/noInventoryData");
const OutfallInventoryData = require("./inventoryData/outfallInventoryData");
const SamplingSiteInventoryData = require("./inventoryData/samplingSiteInventoryData");
